<template>
  <div class="py-3">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-autocomplete
          v-model="formattedLocationCountry"
          :items="countries"
          item-text="name"
          item-value="id"
          label="Country"
          hide-details
          return-object
          :disabled="!editFlag"
          @change="initLocation('country')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-autocomplete
          v-model="formattedLocationRegion"
          :items="regions"
          item-text="name"
          item-value="id"
          label="Region/State/Province"
          hide-details
          return-object
          :disabled="!editFlag"
          @change="initLocation('region')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-autocomplete
          v-model="formattedLocationCity"
          :items="cities"
          item-text="name"
          item-value="id"
          label="City"
          hide-details
          return-object
          :disabled="!editFlag"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import coachApi from '@/api/coach-profile/coach';

export default {
  name: 'LocationEditor',

  props: {
    countries: {
      type: Array,
      default: null,
    },

    order: {
      type: Number,
      default: 0,
    },

    locations: {
      type: Array,
      default: null,
    },

    locationCountry: {
      type: Object,
      default: null,
    },

    locationRegion: {
      type: Object,
      default: null,
    },

    locationCity: {
      type: Object,
      default: null,
    },

    locationTemp: {
      type: Boolean,
      default: false,
    },

    editFlag: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    regions: [],
    cities: [],
  }),

  computed: {
    formattedLocationCountry: {
      get() { return this.locationCountry; },
      set(newValue) { this.$emit('update:locationCountry', newValue); },
    },

    formattedLocationRegion: {
      get() { return this.locationRegion; },
      set(newValue) { this.$emit('update:locationRegion', newValue); },
    },

    formattedLocationCity: {
      get() { return this.locationCity; },
      set(newValue) { this.$emit('update:locationCity', newValue); },
    },

    formattedLocationTemp: {
      get() { return this.locationTemp; },
      set(newValue) { this.$emit('update:locationTemp', newValue); },
    },
  },

  watch: {
    locationCountry: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.countryChanged(newValue, 'init');
        } else {
          this.initLocation('country');
        }
      },
    },

    locationRegion: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.regionChanged(newValue, 'init');
        } else {
          this.initLocation('region');
        }
      },
    },
  },

  created() {
    if (this.locationCountry) {
      this.countryChanged(this.formattedLocationCountry, 'init');
    }
    if (this.locationRegion) {
      this.regionChanged(this.formattedLocationRegion, 'init');
    }
  },

  methods: {
    initLocation(option) {
      this.formattedLocationTemp = true;
      if (option === 'country') {
        this.formattedLocationRegion = null;
        this.formattedLocationCity = null;
      } else if (option === 'region') {
        this.formattedLocationCity = null;
      }
    },

    async countryChanged(value, option) {
      if (value) {
        try {
          this.regions = await coachApi.getRegions(value.id);
          if (!option || option !== 'init') {
            this.initLocation('country');
          }
        } catch (err) {
          console.log(err);
          this.$toast.error(err.msg || err.message);
        }
      } else {
        this.regions = [];
      }
    },

    async regionChanged(value, option) {
      if (value) {
        try {
          this.cities = await coachApi.getCities(value.id);
          if (!option || option !== 'init') {
            this.initLocation('region');
          }
        } catch (err) {
          console.log(err);
          this.$toast.error(err.msg || err.message);
        }
      } else {
        this.cities = [];
      }
    },
  },
};
</script>
